import React, { FC, useEffect, useState } from 'react';

import { HeaderThemedStyle } from './ThemedHeaderStyle';

export interface ThemedHeaderProps {
  cssClass?: string;
  children?: React.ReactNode;
}

export const ThemedHeader: FC<ThemedHeaderProps> = ({
  cssClass = '',
  children,
}) => {
  const [visibilityClass, setVisibilityClass] = useState('invisible');

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisibilityClass('');
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <HeaderThemedStyle className={`${cssClass} ${visibilityClass}`}>
      {children}
    </HeaderThemedStyle>
  );
};
